import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { BankDetail, UcicBanks } from './types';

const getAllCustomerBanks = async (customerId: string) => {
  return axios<UcicBanks, BaseResponse<UcicBanks>, void>({
    url: `/ucic/bank/${customerId}`,
    method: 'put',
  });
};

export const useCustomerBanks = (customerId: string) => {
  const [bankDetails, setbankDetails] = useState<BankDetail[]>([]);

  const { data, isLoading } = useQuery({
    queryKey: ['bank-details', customerId],
    queryFn: () => getAllCustomerBanks(customerId),
    enabled: !!customerId,
    useErrorBoundary: false,
    refetchOnWindowFocus: true,
    retry: 3,
  });

  useEffect(() => {
    const resultData = data?.data?.data.ucicBankList;
    const banks = Array.isArray(resultData) ? resultData : [];

    banks.sort(
      (bank1, bank2) => parseInt(bank1.id, 10) - parseInt(bank2.id, 10)
    );

    setbankDetails(banks);
  }, [data]);

  return {
    bankDetails,
    isLoading,
  };
};
